import { render, staticRenderFns } from "./Infographic5Position.vue?vue&type=template&id=f47f79a2&scoped=true&"
import script from "./Infographic5Position.vue?vue&type=script&lang=js&"
export * from "./Infographic5Position.vue?vue&type=script&lang=js&"
import style0 from "./Infographic5Position.vue?vue&type=style&index=0&id=f47f79a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f47f79a2",
  null
  
)

export default component.exports